import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ImpressumPage() {
  const navigate = useNavigate();

  return (
    <section className="impr">
      <div className="container" style={{ maxWidth: 740 }}>

        <button className="impr__back" onClick={() => navigate(-1)}>
          ← Zurück
        </button>

        <h1 className="impr__title">Impressum</h1>

        <div className="impr__block">
          <h2 className="impr__block-title">Angaben gemäß § 5 TMG</h2>
          <div className="impr__box">
            <p><strong>Huusmacher</strong></p>
            <p>powered by Holthey Immobilien GmbH</p>
            <p>Hinter der Schule 2<br />22145 Stapelfeld</p>
            <br />
            <p>Tel.: 040 18230400</p>
            <p>Fax: 040 18230401</p>
            <p>E-Mail: info@huusmacher.de</p>
            <br />
            <p>Registergericht: AG Lübeck, HRB 19776</p>
            <p>Geschäftsführer: Joachim Schulze</p>
          </div>
        </div>

        <div className="impr__block">
          <h2 className="impr__block-title">Haftungshinweis</h2>
          <div className="impr__text">
            <p>
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
              Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
              deren Betreiber verantwortlich.
            </p>
          </div>
        </div>

        <div className="impr__block">
          <h2 className="impr__block-title">Rechtliche Hinweise</h2>
          <div className="impr__text">
            <p>
              Huusmacher bemüht sich, auf dieser Website nur vollständige und richtige
              Informationen zu veröffentlichen, übernimmt aber keine Haftung oder Garantie
              für Aktualität, Richtigkeit und Vollständigkeit der Informationen.
            </p>
            <p>
              Eine Haftung für Inhalte außerhalb unserer Webseite, auf die mittels Hyperlink
              verwiesen wird, ist ausgeschlossen.
            </p>
          </div>
        </div>

        <div className="impr__block">
          <h2 className="impr__block-title">Datenschutz</h2>
          <div className="impr__text">
            <p>
              Huusmacher verpflichtet sich, Ihre Privatsphäre zu schützen. Diese Website
              verwendet keine Tracking-Cookies und erhebt keine personenbezogenen Daten ohne
              Ihre ausdrückliche Zustimmung.
            </p>
            <p>
              Es gelten die Vorschriften des Bundesdatenschutzgesetzes (BDSG) sowie der
              Datenschutz-Grundverordnung (DSGVO / EU 2016/679).
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
